module.exports = __webpack_public_path__ + "img/21@2x.66f8f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/21@2x.png
// module id = VxMe
// module chunks = 0